<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="title header-tablepage">Cover Sheet</h4>
      <div class="d-flex align-items-center">
        <p
          class="text-link text-gray text-underline mb-0 mr-2"
          @click="clearAll()"
        >
          Clear
        </p>

        <b-button class="btn-filter" @click="openModalPrint()">
          <font-awesome-icon icon="print" />
          Export</b-button
        >
      </div>
    </div>
    <div class="bg-white border-red p-3">
      Document
      <b-input-group class="mb-2">
        <b-form-input
          type="text"
          id="header-search-bar"
          class="search-bar"
          @keyup.enter="searchList()"
          placeholder="Search Document"
          v-model="filter.document_no"
          @paste="onPaste"
          @input="(value, e) => onInput(value, e)"
        />
        <b-input-group-append is-text>
          <b-iconstack font-scale="2" type="submit" @click="searchList()">
            <b-icon stacked icon="search" scale="0.5" variant="grey" />
          </b-iconstack>
        </b-input-group-append>
      </b-input-group>
      <b-row class="my-3">
        <b-col cols="3">
          <InputText
            v-model="form.header"
            textFloat="หัวข้อเอกสาร"
            placeholder="หัวข้อเอกสาร"
          ></InputText>
        </b-col>
        <b-col cols="3">
          <InputDatePickerFilter
            textFloat="วันที่"
            name="date-from"
            ref="date-from"
            v-model="form.date"
          />
        </b-col>

        <b-col cols="3">
          <InputText
            v-model="form.to"
            textFloat="เรียน"
            placeholder="เรียน"
          ></InputText>
        </b-col>
        <b-col cols="3">
          <InputText
            v-model="form.from"
            textFloat="จาก"
            placeholder="จาก"
          ></InputText>
        </b-col>
        <b-col cols="3">
          <InputDatePickerFilter
            textFloat="วันนัดรับ"
            name="duedate"
            ref="duedate"
            v-model="form.duedate"
          />
        </b-col>
      </b-row>

      <b-table
        striped
        responsive
        hover
        :busy="isBusy"
        :items="items"
        :fields="fields"
        class="table-main table-custom"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(weight)="{ item }">
          <div v-if="item.weight">{{ item.weight | numeral("0,0.00") }} </div>
          <div v-else>-</div>
        </template>
        <template #cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }} บาท
        </template>
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(remark)="{ item }">
          {{ item.remark || "-" }}
        </template>

        <template #cell(size)="{ item }">
          {{ item.size || "-" }}
        </template>

        <template #cell(serial)="{ item }">
          {{ item.serial || "-" }}
        </template>
        <template #cell(vendor_code)="{ item }">
          {{ item.vendor_code || "-" }}
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
    </div>
    <ModalConfirm
      ref="confirmModal"
      :text="confirmMsg"
      @handler="confirmDelete"
    />
    <ModalPrint
      ref="modalPrint"
      :formExport="form"
      @success="form = { header: '', date: '', to: '', from: '', duedate: '' }"
    />
  </div>
</template>
<script>
import ModalConfirm from "@/components/modal/ModalConfirm.vue";
import ModalPrint from "./components/ModalPrint.vue";

export default {
  props: {},
  components: { ModalConfirm, ModalPrint },
  name: "Inventory",
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "index", label: "#" },
        { key: "document_no", label: "อ้างอิงเอกสาร" },
        { key: "barcode", label: "รหัสสินค้า" },
        { key: "serial", label: "Serial No." },
        { key: "vendor_code", label: "รหัสสินค้าโรงงาน" },
        { key: "size", label: "Sizes" },
        { key: "weight", label: "น้ำหนัก" },
        { key: "quantity", label: "จำนวน" },
        { key: "remark", label: "รายละเอียด", class: "w-150" },
      ],
      items: [],
      filter: {
        document_no: "",
        user_guid: "",
      },
      rows: 0,
      form: {
        header: "",
        date: "",
        to: "",
        from: "",
        duedate: "",
      },
      confirmMsg: "",

    };
  },
  async created() {
    this.filter.user_guid = this.$cookies.get("print_tag_admin_user_guid");
    await this.getList();
  },
  methods: {
    async searchList() {
      this.isBusy = true;
      await this.$bus.$emit("showLoading");
      const res = await this.axios.post(`/CoverSheet/SearchDoc`, this.filter);
      this.items = res.data.detail;
      await this.axios(`CoverSheet/UpdateJson`);
      await this.$bus.$emit("hideLoading");

      this.isBusy = false;
    },
    async getList() {
      this.isBusy = true;
      await this.$bus.$emit("showLoading");
      const res = await this.axios(`CoverSheet/Get/${this.filter.user_guid}`);
      this.items = res.data.detail;
      await this.$bus.$emit("hideLoading");

      this.isBusy = false;
    },

    openModalPrint() {
      this.$refs.modalPrint.show();
    },
    async confirmDelete() {
      this.$bus.$emit("showLoading");

      const res = await this.axios.delete(
        `/CoverSheet/Clear/${this.filter.user_guid}`
      );
      await this.axios(`CoverSheet/UpdateJson`);
      this.filter = {
        user_guid: this.$cookies.get("print_tag_admin_user_guid"),
        document_no: "",
      };
      this.$bus.$emit("hideLoading");
      await this.getList();
    },

    async clearAll() {
      this.confirmMsg = "Confirm Deletion?";
      this.$refs.confirmModal.show("clear");
    },
    onPaste(e) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      this.ensureData(pasted, e);
    },
    onInput(value, e) {
      this.ensureData(value, e);
    },
    ensureData(value, e) {
      try {
        const url = new URL(value, window.location.origin);
        const docNo = url.searchParams.get("document_no");

        if (docNo) {
          this.filter.document_no = docNo;
          e.preventDefault();
        }
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.input-action {
  position: relative;
  width: 100%;

  ::v-deep .input-custom input {
    cursor: pointer !important;
  }
}

.input-action-icon {
  cursor: pointer;
  position: absolute;
  z-index: 1;
  top: 1px;
  right: 5px;
  width: 32px;
  height: 32px;
  background-color: inherit;
  color: var(--primary-color);
}

.icon-size {
  font-size: 20px;
  color: #575757;
  cursor: pointer;
}
.icon-size.disabled {
  color: #bababa;
}
</style>
